/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Enables the staff executive-report generator (Executive Report, Precision Health, Menopause and Peak Performance report prompts plus the generator UI). Off when absent.
 * @export
 * @interface ExecutiveReportsModule
 */
export interface ExecutiveReportsModule {
    /**
     * 
     * @type {boolean}
     * @memberof ExecutiveReportsModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the ExecutiveReportsModule interface.
 */
export function instanceOfExecutiveReportsModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ExecutiveReportsModuleFromJSON(json: any): ExecutiveReportsModule {
    return ExecutiveReportsModuleFromJSONTyped(json, false);
}

export function ExecutiveReportsModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecutiveReportsModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function ExecutiveReportsModuleToJSON(value?: ExecutiveReportsModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

